const KEY = 'state';

function defaultStorage() {
    if (typeof window !== 'undefined' && window.localStorage) return window.localStorage;
    return null;
}

export function saveToLocalStorage(snapshot, storage = defaultStorage()) {
    if (!storage) return;
    storage.setItem(KEY, JSON.stringify(snapshot));
}

export function loadFromLocalStorage(storage = defaultStorage()) {
    if (!storage) return null;
    const raw = storage.getItem(KEY);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
}

export function clearLocalStorage(storage = defaultStorage()) {
    if (!storage) return;
    storage.removeItem(KEY);
}

export function exportStateBlob({ sessionIdPublic, sessionIdPrivate, topicsSuffix, expiration, snapshot }) {
    const session_id_private = sessionIdPublic && sessionIdPrivate
        ? `${sessionIdPublic}#${sessionIdPrivate}`
        : undefined;
    return JSON.stringify({
        session_id_private,
        topics_suffix: topicsSuffix,
        state: snapshot,
        expiration,
    });
}

export function parseImportedBlob(raw) {
    let parsed;
    if (typeof raw === 'string') {
        try { parsed = JSON.parse(raw); } catch (e) { return null; }
    } else {
        parsed = raw;
    }
    if (!parsed || typeof parsed !== 'object') return null;
    let sessionIdPublic = null;
    let sessionIdPrivate = null;
    if (parsed.session_id_private) {
        const [pub, priv] = String(parsed.session_id_private).split('#');
        if (pub && priv) { sessionIdPublic = pub; sessionIdPrivate = priv; }
    }
    return {
        sessionIdPublic,
        sessionIdPrivate,
        topicsSuffix: parsed.topics_suffix || null,
        expiration: parsed.expiration || null,
        state: parsed.state || null,
    };
}
